import { Component, inject } from '@angular/core';

import { MenuDisplayMode } from '@frontend/vanilla/core';
import { LabelSwitcherService } from '@frontend/vanilla/features/label-switcher';
import { MenuItemComponent } from '@frontend/vanilla/features/menus';

import { AccountMenuItemBase } from '../account-menu-item-base';

@Component({
    imports: [MenuItemComponent],
    selector: 'vn-am-label-switcher-item',
    templateUrl: 'label-switcher-item.html',
})
export class LabelSwitcherItemComponent extends AccountMenuItemBase {
    labelSwitcherService = inject(LabelSwitcherService);

    protected readonly MenuDisplayMode = MenuDisplayMode;
}
